import ModalMainWrapper from './ModalMainWrapper'
import ModalContentWrapper from './ModalContentWrapper'
import ModalHeader from './ModalHeader'
import ModalContent from './ModalContent'
import { useEffect, useState } from 'react'

export default function PdfModal({ title, name, url }) {
    const modalTitle = title || name || 'Preview'
    const proxiedUrl = `/api/proxy-file?url=${encodeURIComponent(url)}`
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        // Failsafe to clear loader if onLoad doesn't fire on some browsers
        const t = setTimeout(() => setLoading(false), 8000)
        return () => clearTimeout(t)
    }, [proxiedUrl])

    return (
        <ModalMainWrapper>
            <ModalContentWrapper>
                <ModalHeader title={modalTitle} />
                <ModalContent>
                    <div className="w-full relative">
                        {loading && (
                            <div className="absolute inset-0 flex items-center justify-center bg-white/60">
                                <div className="flex items-center space-x-2 text-slate-600">
                                    <svg
                                        className="animate-spin h-5 w-5 text-slate-500"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24">
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                                    </svg>
                                    <span className="text-sm">
                                        Loading PDF…
                                    </span>
                                </div>
                            </div>
                        )}
                        <object
                            data={proxiedUrl}
                            type="application/pdf"
                            onLoad={() => setLoading(false)}
                            className="w-full h-[75vh] border border-slate-200 rounded">
                            <p className="text-sm text-olm-black">
                                The PDF preview could not be displayed.{' '}
                                <a
                                    className="underline"
                                    href={url}
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    Open original
                                </a>
                                .
                            </p>
                        </object>
                        <div className="mt-2 text-right space-x-4">
                            <a
                                className="underline text-sm"
                                href={url}
                                target="_blank"
                                rel="noopener noreferrer">
                                Download original
                            </a>
                            <a
                                className="underline text-sm"
                                href={proxiedUrl}
                                target="_blank"
                                rel="noopener noreferrer">
                                Open in viewer
                            </a>
                        </div>
                    </div>
                </ModalContent>
            </ModalContentWrapper>
        </ModalMainWrapper>
    )
}
